var component = require('../../../lib/js/component.js');

function InteractiveLmpCalculator() {

	var $calculator = $('.calculator-icon, .calculator-icon-text');

	function getItems (communityId, itemType, itemId) {
		var apiUrl = itemType.toLowerCase() == "plan" ? '/api/plan/homeplans?communityId=' + communityId
														: '/api/plan/qmiplans?communityId=' + communityId;

		$.ajax({
			type: 'GET',
			context: this,
			// Uncomment for local testing
			// url: 'https://cdk2.dev.pulte.com' + apiUrl,
			url: apiUrl,
			success: function (response) {

				// Filter through all Items in the Community for the item that matches the provided id
				var apiItem = $(response).filter(function (index, item) {
					return item.id == itemId;
				})[0];

				setDefaultValues(apiItem);
			}
		});
	}

	function setDefaultValues (item) {

		if (item.mortgagePayment == null) {
			return;
		}

		var downPaymentDollars = Math.round((item.mortgagePayment.finalPrice * item.mortgagePayment.downPaymentPercentage) / 100);	// Round to whole number
		var downPaymentPercentage = (Math.round(item.mortgagePayment.downPaymentPercentage * 10) / 10).toLocaleString(undefined, {maximumFractionDigits:1});	// Round to 1 decimal place
		var interestRatePercent = (Math.round(item.mortgagePayment.interestRatePercent * 1000) / 1000).toLocaleString(undefined, {maximumFractionDigits:3});	// Round to 3 decimal places

		// Set the default values
		$('.InteractiveLmpCalculator__mortgage-type input').val("30 Year Fixed Rate");	// TODO: Replace this hardcoded value
		$('.InteractiveLmpCalculator__sale-price input').val('$' + Math.round(item.mortgagePayment.finalPrice));	// Round to whole number
		$('.InteractiveLmpCalculator__dollars input').val('$' + downPaymentDollars);
		$('.InteractiveLmpCalculator__percentage input').val(downPaymentPercentage + '%');
		$('.InteractiveLmpCalculator__interest-rate input').val(interestRatePercent + '%');
	}

	this.initialize = function (element) {

		$calculator.on('click', function() {
			if ($calculator == undefined || $calculator.length == 0) {
				return;
			}
	
			this.itemType = $(this).data('itemType');
			this.itemId = $(this).data('itemId');
			this.communityID = $(this).data('communityId');
	
			if (this.communityID) {
				// Get the plan/qmi details for the community and set default values
				getItems(this.communityID, this.itemType, this.itemId);
			}
		});

	}
}

module.exports = component(InteractiveLmpCalculator);
